import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import * as Text from "@/components/text";
import Image from "next/image";
import Link from "next/link";
import { localeTexts } from "@/utils/locale";

export default function DownloadableMaterials({
  data,
  label = "Materiales descargables",
  locale,
  showCategoryLabel = true,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);
  const dataContainer = {};
  const iconsMap = {
    "Guías por películas": "guide.svg",
    "Catálogo de películas": "camera.svg",
    Guías: "guide.svg",
    Postales: "postals.svg",
    "Toolkit editables": "toolkit.svg",
    "Trailer de películas": "films.svg",
  };

  if (data) {
    data.forEach((item) => {
      if (dataContainer[item.category]) {
        dataContainer[item.category].push(item);
      } else {
        dataContainer[item.category] = [item];
      }
    });
  }
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight);
    }
  }, [isOpen]);

  const getCategoryText = (category) => {
    if (locale === "en") {
      const categoryTranslations = {
        "Guías por películas": "Guides by film",
        "Catálogo de películas": "Film catalogue",
        Guías: "Guides",
        Postales: "Postcards",
        "Toolkit editables": "Editable toolkits",
        "Trailer de películas": "Film trailers",
      };
      return categoryTranslations[category] || category;
    }
    return category;
  };

  return (
    <div className="w-full mb-8 border-t-2 border-b-2 border-neutral-300">
      <button
        className="flex w-full items-center justify-center py-2 text-2xl font-light lg:py-4 lg:text-[40px]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="mr-4">{label}</span>
        {isOpen ? (
          <ChevronUpIcon className="w-6 lg:w-12" />
        ) : (
          <ChevronDownIcon className="w-6 lg:w-12" />
        )}
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="w-full overflow-hidden"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: contentHeight, opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              type: "spring",
              stiffness: 140,
              damping: 15,
              duration: 0.2,
            }}
          >
            <div ref={contentRef} className="pb-4 amb-container">
              {Object.entries(dataContainer).map(([category, items]) => (
                <div key={category} className="mt-6 mb-8 category lg:mb-4">
                  {showCategoryLabel && (
                    <Text.Body className="w-full text-xs uppercase tracking-[.96px] text-neutral-500">
                      {getCategoryText(category)}
                    </Text.Body>
                  )}
                  <div className="grid justify-between grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    {items.map((item, index) => (
                      <Link
                        key={index}
                        passHref
                        href={item.url}
                        target="_blank"
                      >
                        <div className="flex my-4 item lg:my-2 ">
                          <Image
                            alt="item icon"
                            height={16}
                            width={16}
                            src={`/next_assets/icons/${iconsMap[category]}`}
                          ></Image>
                          <Text.Body className="ml-1 text-sm font-semibold">
                            {item.title}
                          </Text.Body>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
